import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Whitepaper from './pages/Whitepaper';
import Roadmap from './pages/Roadmap';
import Analytics from './pages/Analytics';
import Rarity from './Rarity';
import { WalletProvider } from './contexts/WalletContext';

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <WalletProvider>
      <BrowserRouter>
        <div className="site">
          <nav className="site-nav">
            <div className="site-brand">
              <Link to="/" className="brand-link">NFT-People</Link>
            </div>
            
            {/* Desktop Navigation */}
            <div className="site-links desktop-nav">
              <Link to="/" className="nav-link">Home</Link>
              <Link to="/whitepaper" className="nav-link">Whitepaper</Link>
              <Link to="/roadmap" className="nav-link">Roadmap</Link>
              <Link to="/analytics" className="nav-link">Analytics</Link>
              <Link to="/rarity" className="nav-link cta">Rarity Tool</Link>
            </div>

            {/* Mobile Hamburger Button */}
            <button 
              className="mobile-menu-toggle"
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
            >
              <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>

            {/* Mobile Navigation */}
            <div className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
              <Link to="/" className="nav-link" onClick={closeMobileMenu}>Home</Link>
              <Link to="/whitepaper" className="nav-link" onClick={closeMobileMenu}>Whitepaper</Link>
              <Link to="/roadmap" className="nav-link" onClick={closeMobileMenu}>Roadmap</Link>
              <Link to="/analytics" className="nav-link" onClick={closeMobileMenu}>Analytics</Link>
              <Link to="/rarity" className="nav-link cta" onClick={closeMobileMenu}>Rarity Tool</Link>
            </div>
          </nav>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/whitepaper" element={<Whitepaper />} />
            <Route path="/roadmap" element={<Roadmap />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/rarity" element={<Rarity />} />
          </Routes>
        </div>
      </BrowserRouter>
    </WalletProvider>
  );
}

export default App;
